import { render, staticRenderFns } from "./ConfiguracionNotificaciones.vue?vue&type=template&id=04e8469d&"
import script from "./ConfiguracionNotificaciones.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionNotificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports